import "@/App.css";
import React from "react";
import { Toaster } from "sonner";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import useLenis from "@/hooks/useLenis";
import { CartProvider } from "@/hooks/useCart";
import { AuthProvider } from "@/hooks/useAuth";
import Nav from "@/components/Nav";
import Footer from "@/components/Footer";
import CartDrawer from "@/components/CartDrawer";
import KidsSkyOverlay from "@/components/KidsSkyOverlay";
import ScrollToHash from "@/components/ScrollToHash";
import Home from "@/pages/Home";
import StoryPage from "@/pages/StoryPage";
import ShopPage from "@/pages/ShopPage";
import BookPage from "@/pages/BookPage";
import ColoringPage from "@/pages/ColoringPage";
import QuizPage from "@/pages/QuizPage";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import LoginPage from "@/pages/LoginPage";
import AdminPage from "@/pages/AdminPage";
import AuthCallback from "@/pages/AuthCallback";

function AppRouter() {
  const location = useLocation();
  // Emergent Google Auth returns to any URL with #session_id=... in the hash.
  // Route synchronously to AuthCallback so it processes before ProtectedRoute logic runs.
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/bajka/:slug" element={<StoryPage />} />
      <Route path="/sklep" element={<ShopPage />} />
      <Route path="/ksiazka/:slug" element={<BookPage />} />
      <Route path="/kolorowanki" element={<ColoringPage />} />
      <Route path="/quiz" element={<QuizPage />} />
      <Route path="/payment/success" element={<PaymentSuccess />} />
      <Route path="/payment/cancel" element={<PaymentCancel />} />
      <Route path="/login" element={<LoginPage mode="login" />} />
      <Route path="/register" element={<LoginPage mode="register" />} />
      <Route path="/admin" element={<AdminPage />} />
      <Route path="/auth/callback" element={<AuthCallback />} />
      <Route path="*" element={<Home />} />
    </Routes>
  );
}

function Shell() {
  useLenis();
  return (
    <div className="relative min-h-screen bg-[#F4FAFF] text-[#051937]" data-testid="app-root">
      <div className="grain" />
      <KidsSkyOverlay />
      <ScrollToHash />
      <Nav />
      <main>
        <AppRouter />
      </main>
      <CartDrawer />
      <Footer />
      <Toaster
        position="top-right"
        toastOptions={{
          style: {
            background: "#ffffff",
            color: "#051937",
            border: "1px solid #BAE6FD",
            borderRadius: "999px",
            fontWeight: 600,
          },
        }}
      />
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <CartProvider>
          <Shell />
        </CartProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
